<svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M40.0007 24.0001H8.00073" stroke="#000"/>
<path d="M25.0007 10.0001L40.0007 24.0001L25.0007 38.0001" stroke="#000"/>
</svg>
